// Select the elements
const conditionSearch = document.querySelector('.conditions-and-treatments-tool--sticky');
const conditionSearchStatic = document.querySelector('.conditions-and-treatments-tool--static');
const conditionList = document.querySelector('.conditions-and-treatments-listing');

function isCondensed() {

  console.log('Running isCondensed function');

  // Ensure condensed class is always added for small viewports
  if (conditionSearch && window.innerWidth < 900) {
    conditionSearch.classList.add('is-condensed');
  } else if (!conditionSearch.classList.contains('is-sticky')) {
    conditionSearch.classList.remove('is-condensed');
  }

  if (conditionSearchStatic && window.innerWidth < 900) {
    conditionSearchStatic.classList.add('is-condensed');
  } else {
    conditionSearchStatic.classList.remove('is-condensed');
  }
}

// Check if elements exist
if (conditionSearch && conditionList) {
  const handleScroll = () => {
    // Get the bounding rectangles of the elements
    const conditionListRect = conditionList.getBoundingClientRect();

    // Check if conditionSearch has reached the top of conditionList
    if (conditionListRect.top <= 0 && conditionListRect.bottom > 100) {
      conditionSearch.classList.add('is-sticky', 'is-condensed');
      conditionSearch.classList.remove('is-hidden');
    } else {
      conditionSearch.classList.remove('is-sticky', 'is-condensed');
    }

    // Check if conditionList is at the top of the viewport
    if (conditionListRect.bottom <= 100) {
      conditionSearch.classList.add('is-hidden');
    } else {
      conditionSearch.classList.remove('is-hidden');
    }

    // Ensure 'is-condensed' displays by default for viewports below 900px
    if (window.innerWidth < 900) {
      conditionSearch.classList.add('is-condensed');
    }
  };

  // Add event listeners
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', isCondensed);

  // Initialize isCondensed
  isCondensed();
}
